import React, { useState } from 'react'
import "./Login.css"

import { useNavigate } from 'react-router-dom'
import { toast } from 'sonner'
import { useDispatch } from 'react-redux'
import { LoginUser } from '../../Services/Operations/ProductAPI'
import { setCredentials, setUser } from '../../Store/authSlice'



const styles = {
  page: {
    margin: 0,
    padding: 0,
    minHeight: "100vh",
    width: "100vw",
    background: "#0d0d0d",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "'DM Sans', sans-serif",
  },
  card: {
    background: "#f1eb77",
    borderRadius: "24px",
    width: "100%",
    maxWidth: "420px",
    padding: "2.75rem 2.5rem 2.25rem",
    position: "relative",
    overflow: "hidden",
    boxSizing: "border-box",
  },
  decorCircle1: {
    position: "absolute",
    top: "-70px",
    right: "-70px",
    width: "180px",
    height: "180px",
    background: "rgba(0,0,0,0.07)",
    borderRadius: "50%",
    pointerEvents: "none",
  },
  decorCircle2: {
    position: "absolute",
    bottom: "-50px",
    left: "-50px",
    width: "140px",
    height: "140px",
    background: "rgba(0,0,0,0.05)",
    borderRadius: "50%",
    pointerEvents: "none",
  },
  brandRow: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    marginBottom: "2.25rem",
  },
  brandDot: {
    width: "9px",
    height: "9px",
    background: "#0d0d0d",
    borderRadius: "50%",
  },
  brandName: {
    fontSize: "12px",
    fontWeight: "700",
    color: "#0d0d0d",
    letterSpacing: "0.1em",
    textTransform: "uppercase",
  },
  heading: {
    fontFamily: "'DM Serif Display', serif",
    fontSize: "2.6rem",
    color: "#0d0d0d",
    lineHeight: "1.08",
    margin: "0 0 0.4rem",
  },
  subtext: {
    fontSize: "13.5px",
    color: "#3d3b1a",
    margin: "0 0 2rem",
    fontWeight: "400",
  },
  fieldGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "14px",
    marginBottom: "10px",
  },
  fieldWrap: {
    display: "flex",
    flexDirection: "column",
    gap: "5px",
  },
  label: {
    fontSize: "11px",
    fontWeight: "700",
    color: "#2b2a10",
    letterSpacing: "0.09em",
    textTransform: "uppercase",
  },
  input: {
    background: "rgba(255,255,255,0.5)",
    border: "1.5px solid rgba(0,0,0,0.13)",
    borderRadius: "10px",
    padding: "12px 14px",
    fontSize: "15px",
    fontFamily: "'DM Sans', sans-serif",
    color: "#0d0d0d",
    outline: "none",
    width: "100%",
    boxSizing: "border-box",
    transition: "border-color 0.18s, background 0.18s",
  },
  inputFocus: {
    border: "1.5px solid #0d0d0d",
    background: "rgba(255,255,255,0.82)",
  },
  forgotRow: {
    display: "flex",
    justifyContent: "flex-end",
    margin: "8px 0 1.5rem",
  },
  forgotLink: {
    fontSize: "12.5px",
    color: "#2b2a10",
    textDecoration: "underline",
    textUnderlineOffset: "2px",
    cursor: "pointer",
    fontWeight: "500",
    background: "none",
    border: "none",
    padding: 0,
    fontFamily: "inherit",
  },
  loginBtn: {
    width: "100%",
    background: "#0d0d0d",
    color: "#F0E633",
    border: "none",
    borderRadius: "10px",
    padding: "14px",
    fontSize: "15px",
    fontWeight: "600",
    fontFamily: "'DM Sans', sans-serif",
    cursor: "pointer",
    letterSpacing: "0.03em",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    transition: "background 0.15s, transform 0.1s",
  },
  dividerWrap: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    margin: "1.25rem 0",
  },
  dividerLine: {
    flex: 1,
    height: "1px",
    background: "rgba(0,0,0,0.15)",
  },
  dividerText: {
    fontSize: "12px",
    color: "#5a5830",
    fontWeight: "500",
  },
  registerRow: {
    textAlign: "center",
    fontSize: "13.5px",
    color: "#2b2a10",
    margin: 0,
  },
  registerLink: {
    fontWeight: "700",
    color: "#0d0d0d",
    cursor: "pointer",
    textDecoration: "underline",
    textUnderlineOffset: "2px",
  },
};

// Inject Google Fonts once
const fontLink = document.createElement("link");
fontLink.rel = "stylesheet";
fontLink.href =
  "https://fonts.googleapis.com/css2?family=DM+Serif+Display&family=DM+Sans:wght@300;400;500;600;700&display=swap";
if (!document.head.querySelector("[href*='DM+Sans']")) {
  document.head.appendChild(fontLink);
}

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [focusedField, setFocusedField] = useState(null);
  const [btnHover, setBtnHover] = useState(false);

    const navigate=useNavigate()
    const dispatch=useDispatch()


    const handleLogin=async()=>{
        try {
            setLoading(true)
            let data={
                email,password
            }
            const res= await LoginUser(data)
            console.log(res);
            if(res.status===200){
                toast.success("Login successful")
                console.log({user:res.data.data,token:res.data.token});
                
                dispatch(setCredentials({user:res.data.data,token:res.data.token}))
                dispatch(setUser(res.data.data))
                navigate("/")
            }else{
                toast.info("Wrong credentials")
            }
            
        } catch (error) {
            console.log(error);
            toast.error("Failed to login")
            
        }finally{
              setLoading(false)
        }
    }

     const nave = (path) => {
    // replace with your router navigate
    navigate(path)
    console.log("Navigate to", path);
  };

  const inputStyle = (field) => ({
    ...styles.input,
    ...(focusedField === field ? styles.inputFocus : {}),
  });
  return (
    <div style={styles.page}>
      <div style={styles.card}>
        {/* Decorative circles */}
        <div style={styles.decorCircle1} />
        <div style={styles.decorCircle2} />

        {/* Brand */}
        <div style={styles.brandRow}>
          <div style={styles.brandDot} />
          <span style={styles.brandName}>Dhanushdhari RealEstate</span>
        </div>

        {/* Heading */}
        <h1 style={styles.heading}>
          Welcome<br />back.
        </h1>
        <p style={styles.subtext}>Sign in to continue your session</p>

        {/* Fields */}
        <div style={styles.fieldGroup}>
          <div style={styles.fieldWrap}>
            <label style={styles.label}>Email</label>
            <input
              style={inputStyle("email")}
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onFocus={() => setFocusedField("email")}
              onBlur={() => setFocusedField(null)}
            />
          </div>

          <div style={styles.fieldWrap}>
            <label style={styles.label}>Password</label>
            <input
              style={inputStyle("password")}
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onFocus={() => setFocusedField("password")}
              onBlur={() => setFocusedField(null)}
            />
          </div>
        </div>

        {/* Forgot */}
        <div style={styles.forgotRow}>
          <button style={styles.forgotLink}>Forgot password?</button>
        </div>

        {/* Login Button */}
        <button
          style={{
            ...styles.loginBtn,
            background: btnHover ? "#222" : "#0d0d0d",
            transform: btnHover ? "scale(0.985)" : "scale(1)",
          }}
          onClick={handleLogin}
          onMouseEnter={() => setBtnHover(true)}
          onMouseLeave={() => setBtnHover(false)}
          disabled={loading}
        >
          {loading ? "Signing in..." : "Sign in"}
          {!loading && <span style={{ fontSize: "18px", lineHeight: 1 }}>→</span>}
        </button>

        {/* Divider */}
        <div style={styles.dividerWrap}>
          <div style={styles.dividerLine} />
          <span style={styles.dividerText}>New here?</span>
          <div style={styles.dividerLine} />
        </div>

        {/* Register */}
        <p style={styles.registerRow}>
          Don't have an account?{" "}
          <span style={styles.registerLink} onClick={() => navigate("/register")}>
            Register
          </span>
        </p>
      </div>
    </div>
  )
}

export default Login
